
export const listAuctionsQuery = `query listAuctions($endTime: String!) {
  listAuctions(filter: {EndTime: {ge:$endTime}}) {
    items {
      AuctionCode
      AuctionId
      Title
      Description
      Status
      StartTime
      EndTime
      Items {
        ItemId
      }
      FixedItems {
        FixedItemId
      }
      AuctionLocation
      BannerImageName
      NeedsCheckin
      AllowVisitorView
      EventRegSiteUrl
      HasDonation
      IncludeFundraisingGoal
      FundraisingGoal
      LowDonationAmount
      MidDonationAmount
      HighDonationAmount
      TotalDonations
      OrganizerAddress
      OrganizerLogoName
      OrganizerName
      OrganizerWebsite
      SupportEmail
      SupportPhone
      FundNumber
      FundName
      MarketingEffortNumber
      MarketingEffortName
      ItemCategories
    }
  }
}`

// gets UserId from CognitoLogin, which it gets from the user's ID token
export const getAuctionUserQuery = `query getUser {
  getUser {
    CrmId
    FirstName
    LastName
    ContactPhone
    ContactEmail
    UserId
    isTestUser
    Permissions {
      AuctionId
      AdminPermissions
    }
    Address {
      Street1
      Street2
      City
      State
      PostCode
      Country
    }
    PaymentMethods {
      CardType,
      NameOnCard,
      Last4,
      Expires,
      DateAdded,
    }
    MyAuctions {
      RegistrationId
      AuctionId
      TextAlertNumber
      IsCheckedIn
      QrBase64
      DateCreated
      Favorites
      Donations {
        Amount
        Timestamp
      }
      DonationTotal
      DonationPayment
      Auction {
        AuctionCode
        AuctionId
        Title
        Description
        Status
        StartTime
        EndTime
        AuctionLocation
        BannerImageName
        OrganizerName
        OrganizerLogoName
        OrganizerAddress
        OrganizerWebsite
        SupportEmail
        SupportPhone
        FundNumber
        FundName
        MarketingEffortNumber
        MarketingEffortName
        NeedsCheckin
        AllowVisitorView
        EventRegSiteUrl
        HasDonation
        IncludeFundraisingGoal
        FundraisingGoal
        LowDonationAmount
        MidDonationAmount
        HighDonationAmount
        TotalDonations
        Items {
          CurrentBid
          CurrentHighBidder
          Title
          Paid
          ItemId
        }
        FixedItems {
          Title
          FixedItemId
          PurchasePrice
          Purchases {
            UserId
            Quantity
          }
          Payments {
            UserId
            Quantity
          }
        }
      }
    }
  }
}`

export const getCollaboratorPermissionsQuery = `query getCollaboratorPermissions {
  getCollaboratorPermissions {
    AuctionId
    AdminPermissions
  }
}`

export const adminSearchFundsQuery = `query adminSearchFunds($fund: String!) {
  adminSearchFunds(fund: $fund) {
    lookupId
    designationName
    publicName
    schoolName
    divisionName
    departmentName
  }
}`

export const adminValidateMarketingEffortQuery = `query adminValidateMarketingEffort($meNumber: String!) {
  adminValidateMarketingEffort(meNumber: $meNumber) {
    appealId
    marketingEffortName
  }
}`

// gets UserId from CognitoLogin, which it gets from the user's ID token
export const getBraintreeClientTokenQuery = `query getBraintreeClientToken {
  getBraintreeClientToken {
    ClientToken
    ResponseData
  }
}`

const getCommonQueryFinish = (auctionAdminData, itemAdminData, fixedItemAdminData) => `
  Items {
      Donor
      ImageFilename
      MinRaise
      StartingBid
      Value
      Title
      ItemId
      CurrentHighBidder
      ItemCode
      Description
      CurrentBid
      BidCount
      AuctionId
      CurrentHighBidder
      Paid
      Category
      ${itemAdminData ? itemAdminData : ""}
    }
    FixedItems {
      FixedItemId
      ItemCode
      AuctionId
      Title
      Description
      Donor
      ImageFilename
      Value
      PurchasePrice
      TotalItemsAvailable
      TotalItemsRemaining
      LimitPerPerson
      TotalItemsPurchased
      Category
      Purchases {
        UserId
        Quantity
        Timestamp
        ${fixedItemAdminData ?  `FullName` : ""}
      }
      Payments {
        UserId
        Quantity
        ${fixedItemAdminData ? fixedItemAdminData : ""}
      }
    }
    AuctionCode
    AuctionId
    Title
    Description
    Status
    StartTime
    EndTime
    BannerImageName
    AuctionLocation
    OrganizerName
    OrganizerLogoName
    OrganizerAddress
    OrganizerWebsite
    SupportEmail
    SupportPhone
    FundNumber
    FundName
    MarketingEffortNumber
    MarketingEffortName
    NeedsCheckin
    AllowVisitorView
    EventRegSiteUrl
    HasDonation
    IncludeFundraisingGoal
    FundraisingGoal
    LowDonationAmount
    MidDonationAmount
    HighDonationAmount
    TotalDonations
    ItemCategories
    ItemDisplayOrder {
      ItemType
      ItemId
    }
    Bids {
      BidAmount
      ItemId
      FullName
      Timestamp
      UserId
    }
    ${auctionAdminData ? auctionAdminData : ""}
  }
}`

export const getAuctionByIdQuery = `query getAuctionById($auctionId: String!) {
  getAuction(AuctionId: $auctionId) {`
  + getCommonQueryFinish()

export const getAuctionByCodeQuery = `query getAuctionByCode($auctionCode: String!) {
  getAuctionByCode(AuctionCode: $auctionCode) {`
  + getCommonQueryFinish()


///////////////////////////////////////////////////////////////////////////////////////
/// Admin only queries ////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////

export const adminListAuctionsQuery = `query adminListAuctions($status: String = "ALL") {
  adminListAuctions(filter: {Status: {eq:$status}}) {
    items {
      AuctionCode
      AuctionId
      Title
      Description
      Status
      ReviewStatus
      StartTime
      EndTime
      Items {
        BidCount
        ItemId
        Paid
      }
      FixedItems {
        FixedItemId
      }
      AuctionLocation
      BannerImageName
      NeedsCheckin
      AllowVisitorView
      EventRegSiteUrl
      HasDonation
      IncludeFundraisingGoal
      FundraisingGoal
      LowDonationAmount
      MidDonationAmount
      HighDonationAmount
      TotalDonations
      OrganizerAddress
      OrganizerLogoName
      OrganizerName
      OrganizerWebsite
      OwnerId
      OwnerEmail
      SupportEmail
      SupportPhone
      FundNumber
      FundName
      MarketingEffortNumber
      MarketingEffortName
      Permissions {
        Email
        AdminPermissions
      }
      ItemCategories
      Registrations {
        RegistrationId
        EventHubRegistrationId
        DateCreated
        DonationTotal
        DonationPayment
        User {
          UserId
          ContactEmail
          CrmId
          ContactPhone
          FirstName
          LastName
        }
      }
    }
  }
}`

export const adminGetAuctionImagePresignedUrlQuery = `query adminGetAuctionImagePresignedUrl($auctionCode: String!, $itemId: String!, $fileName: String!, $contentType: String!) {
  getPresignedUrlForUpload(AuctionCode: $auctionCode, ItemId: $itemId, FileName: $fileName, ContentType: $contentType) {
    PresignedUrl
    ResponseData
  }
}`

export const adminFindUserQuery = `query adminFindUser($cognitoLogin: String!) {
  adminFindUser(CognitoLogin: $cognitoLogin) {
    CrmId
    FirstName
    LastName
    ContactPhone
    ContactEmail
    UserId
  }
}`

// used by admin user to get more info on high bidders, will not work if called by non-admin user
export const adminGetAuctionByCodeQuery = `query adminGetAuctionByCode($auctionCode: String!) {
  adminGetAuctionByCode(AuctionCode: $auctionCode) {`
  + getCommonQueryFinish(`OwnerId
                          OwnerEmail
                          ReviewStatus
                          EventHubEventId
                          EventHubRegistrations {
                            RegistrationId
                            RegistrationStatus
                          }
                          Permissions {
                            Email
                            AdminPermissions
                          }
                          Registrations {
                            RegistrationId
                            EventHubRegistrationId
                            DateCreated
                            DonationTotal
                            DonationPayment
                            User {
                              UserId
                              ContactEmail
                              CrmId
                              ContactPhone
                              FirstName
                              LastName
                            }
                          }`,
                         `PaymentDetails
                          CurrentHighBidderInfo {
                            ContactEmail
                            ContactPhone
                            CrmId
                            FirstName
                            LastName
                         }`,
                         `  FullName
                            Timestamp
                            PaymentDetails
                           `)

// used by admin user to get more info on high bidders, will not work if called by non-admin user
export const collaboratorGetAuctionByCodeQuery = `query adminGetAuctionByCode($auctionCode: String!) {
  adminGetAuctionByCode(AuctionCode: $auctionCode) {`
  + getCommonQueryFinish(`OwnerId
                          OwnerEmail
                          ReviewStatus
                          EventHubEventId
                          EventHubRegistrations {
                            RegistrationId
                            RegistrationStatus
                          }
                          Permissions {
                            Email
                            AdminPermissions
                          }
                          Registrations {
                            RegistrationId
                            EventHubRegistrationId
                            DateCreated
                            DonationTotal
                            DonationPayment
                            User {
                              UserId
                              FirstName
                              LastName
                            }
                          }`,
                         `PaymentDetails
                          CurrentHighBidderInfo {
                            FirstName
                            LastName
                         }`)
